import getStores from './getStores';
import {FlashMessageOptions} from '../components/flash-messages-service/flashMessageTypes';

function raiseFlashMessage(options: FlashMessageOptions) {
  const {flashMessageStore} = getStores('flashMessageStore');
  flashMessageStore.addFlashMessage(options);
}

export default raiseFlashMessage;
